import {
  ChartOptions,
  LegendOptions,
  ScrollbarOptions,
  TooltipOptions,
} from 'highcharts';

export const WIDGET_CONTENT_HEIGHT = 280;
export const WIDGET_CONTENT_HEIGHT_WITH_SCROLLBAR = 305;

export const getDefaultChartOptions = (): ChartOptions => ({
  type: 'column',
  height: WIDGET_CONTENT_HEIGHT,
  style: {
    fontFamily: 'var(--font-family)',
  },
  events: {
    load: (event: any) => {
      event.target.reflow();
    },
    redraw() {
      this.series.forEach((series) => {
        series.points.forEach((point) => {
          if ((point as any).dataLabel) {
            (point as any).dataLabel.attr({ visibility: 'visible' });
          }
        });
      });
    },
  },
  marginBottom: 45,
});

export const getDefaultTooltipOptions = (): TooltipOptions => ({
  backgroundColor: '#fff',
  borderColor: '#e0e0e0',
  borderRadius: 2,
});

export const getDefaultScrollBarOptions = (): ScrollbarOptions => ({
  barBackgroundColor: 'gray',
  barBorderRadius: 4,
  barBorderWidth: 0,
  buttonBackgroundColor: 'white',
  buttonBorderWidth: 0,
  buttonArrowColor: 'white',
  height: 8,
  rifleColor: 'gray',
  trackBackgroundColor: '#f4f1f1',
  liveRedraw: true,
  trackBorderRadius: 8,
  margin: 0,
});

export const getLegendOptions = (): LegendOptions => ({
  enabled: true,
  align: 'right',
  verticalAlign: 'top',
  maxHeight: 80,
  navigation: {
    arrowSize: 12,
  },
  itemStyle: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 120,
    fontWeight: 'var(--font-weight-normal)',
  },
});
